module.exports = __webpack_public_path__ + "static/img/douyin.738ea067.png";